import React from 'react';
import { FC } from 'react';

export const Tail: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vTNqrW0J_hzMheQX_jfs0OyjhDsfHJBnZaPq-XHRcPFd5zZaGEbPqEQZPEAJdfVzJJ30VqfsTpT7yYk/embed?start=false&loop=false&delayms=3000"
                 width="1200" height="675"></iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};